import { render, staticRenderFns } from "./BoardsArchive.vue?vue&type=template&id=c41c7256&"
import script from "./BoardsArchive.vue?vue&type=script&lang=js&"
export * from "./BoardsArchive.vue?vue&type=script&lang=js&"
import style0 from "./BoardsArchive.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports